import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import {sectionPaperStyling} from './estimate-view-v4';
import {SectionHeader} from './header-section';

export const PfrDetailsSection = ({
                             doBenefitsReset,
                             isPfrAdjustedForPriorCare,
                             estimatedDeductible,
                             estimatedCopay,
                             estimatedCoinsurance,
                             oopMaxRemaining,
                             pfrForCoveredServices,
                             pfrForUncoveredServices,
                             admissionAssessment,
                             estimatedPFR,
                             isWithCrossover,
                           }: {
  doBenefitsReset: boolean
  isPfrAdjustedForPriorCare: boolean
  estimatedDeductible?: number
  estimatedCopay?: number
  estimatedCoinsurance?: number
  oopMaxRemaining?: number
  pfrForCoveredServices?: number
  pfrForUncoveredServices?: number
  admissionAssessment?: number
  estimatedPFR?: number
  isWithCrossover: boolean
}) => {

  const pfrRows = [
    // {label: 'Do Benefits Reset any time during the Care Plan?', value: doBenefitsReset ? 'Yes' : 'No'},
    // {
    //   label: 'Is PFR Estimate Adjusted for Prior Care from the Past 30-45 Days?',
    //   value: isPfrAdjustedForPriorCare ? 'Yes' : 'No',
    // },
    {
      label: 'Estimated Deductible',
      value: typeof estimatedDeductible === 'number' ?
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(estimatedDeductible) :
          '',
    },
    {
      label: 'Estimated Copay',
      value: typeof estimatedCopay === 'number' ?
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(estimatedCopay) :
          '',
    },
    {
      label: 'Estimated Coinsurance',
      value: typeof estimatedCoinsurance === 'number' ?
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(estimatedCoinsurance) :
          '',
    },
  ];

  const outOfPocketRow = {
    label: 'Out of Pocket Max Remaining',
    value: typeof oopMaxRemaining === 'number' ?
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(oopMaxRemaining) :
        '',
  };

  const pfrSummary = {
    coveredServices: typeof pfrForCoveredServices === 'number' ?
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(pfrForCoveredServices) :
        '',
    uncoveredServices: typeof pfrForUncoveredServices === 'number' ?
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(pfrForUncoveredServices) :
        '',
    admissionAssessment: typeof admissionAssessment === 'number' ?
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(admissionAssessment) :
        '',
    total: typeof estimatedPFR === 'number' ?
        new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(estimatedPFR) :
        '',
  };

  let estimateTotal =  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format((estimatedDeductible || 0) + (estimatedCopay || 0) + (estimatedCoinsurance || 0))

  return (
      <Box mb={4}>
        <SectionHeader
            title="PFR Details"
            subtitle={isWithCrossover ? 'With Crossover' : undefined}
            testId="pfr-details-title"
        />
        <Paper
            component={Box}
            sx={{
              ...sectionPaperStyling
            }}
        >
          <Table
              size="small"
              sx={{
                '& td': {borderBottom: 'none', paddingY: 1.2},
              }}
          >
            <TableBody>
              {pfrRows.map(row => (
                  <TableRow key={row.label}>
                    <TableCell>{row.label}</TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                  </TableRow>
              ))}
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="right">
                  <Box
                      sx={{
                        borderTop: '1px solid #000',
                        width: '70%',
                        ml: 'auto',
                      }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="right" sx={{fontWeight: 600}}>
                  {/*{estimateTotal}*/}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{pt: 2, fontWeight: 600}}>
                  {outOfPocketRow.label}
                </TableCell>
                <TableCell align="right" sx={{pt: 2, fontWeight: 600}}>
                  {outOfPocketRow.value}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <Box
            sx={{
              mt: 2,
              backgroundColor: '#e6f4e6',
              overflow: 'hidden',
              ...sectionPaperStyling
            }}
        >
          <Table size="small"
                 sx={{'& td': {borderBottom: 'none', paddingY: 1.2}}}>
            <TableBody>
              <TableRow>
                <TableCell>PFR for Covered Services</TableCell>
                <TableCell
                    align="right">{pfrSummary.coveredServices}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>PFR for Uncovered Services</TableCell>
                <TableCell
                    align="right">{pfrSummary.uncoveredServices}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Admission Assessment</TableCell>
                <TableCell
                    align="right">{pfrSummary.admissionAssessment}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography variant="subtitle2">
                    Estimated Patient Financial Responsibility (PFR)
                  </Typography>
                </TableCell>
                <TableCell
                    align="right"
                >
                  <Typography
                      variant="subtitle2">{pfrSummary.total}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
  );
}